
//============================================================================
// Name        : integrations.ts
// Purpose     : Implement integrations page dynamic behaviors
// Created     : 2020-03-23
// Author      : Senitron Team
// Copyright   : Copyright 2020 Senitron Corporation. All rights reserved.
//============================================================================

import {InitPage} from "../index";
import * as Toastr from "toastr";

class Integrations {
    constructor () {
        $('.show-message').on('click', function(){
            Toastr.error("Please add shop-ID first and retry");
            $("#editIntegration").modal("hide");
        });
    }

    init() {
        $(".edit-integrations").on("click", (e) => this.onSelectEditDialog(e.target));
    }

    // openPopUpWindow(url) {
    //     // Launch Popup
    //     const width = 800;
    //     const height = 650;
    //
    //     let top = window.screen.height - height;
    //     top = top > 0 ? top/2 : 0;
    //
    //     let left = window.screen.width - width;
    //     left = left > 0 ? left/2 : 0;
    //
    //     const parameters = "location=1,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left;
    //     const win = window.open(url,"Connect to QuickBooks", parameters);
    //     win.moveTo(left, top);
    //     win.focus();
    // }

    onSelectEditDialog = async (el: HTMLElement) => {
        const btnEl = $(el);
        this.hideAllElements();
        if(btnEl.data("title") != "quickbook")
            this.showGeneralFields();
        if (btnEl.data("title") == "auditlogs") {
            this.showFormOfPostLog();
        } else if (btnEl.data("title") == "treez") {
            this.showFormOfTreez();
        } else if (btnEl.data("title") == "odoo") {
            this.showFormOfOdoo();
        } else if (btnEl.data("title") == "heartland") {
            this.showFormOfHeartland();
        } else if (btnEl.data("title") == "vend") {
            this.showFormOfVend();
        } else if (btnEl.data("title") == "shopify") {
            this.showFormOfShopify();
        } else if (btnEl.data("title") == "lightspeed") {
            this.showCredentialFields();
            this.showFormOfLightspeed();
        } else if (btnEl.data("title") == "ls_pos") {
            this.showFormOfLightspeedPos();
        } else if (btnEl.data('title') === 'twilio') {
            this.showFormOfTwilio();
        } else if (btnEl.data("title") == "quickbook") {
            // this.showCredentialFields();
            this.showFormOfQuickBook();
        } else {
            this.showCredentialFields();
        }
        this.showDownloadCatalog(el);
        this.onEditIntegration(el);
    }

    onEditIntegration = async (el: HTMLElement) => {

        const btnEl = $(el);
        $("#username").val(btnEl.data("username"));
        $("#password").val(btnEl.data("password"));
        $("#url").val(btnEl.data("url"));
        $("#api_key").val(btnEl.data("api_key"));
        $("#api_secret_key").val(btnEl.data("api_secret_key"));
        $("#dispensary_name").val(btnEl.data("dispensary_name"));
        $("#ext_client_id").val(btnEl.data("ext_client_id"));
        $("#license").val(btnEl.data("license"));
        $("#error_email").val(btnEl.data("error_email"));
        $("#token").val(btnEl.data("token"));
        $("#domain_prefix").val(btnEl.data("domain-prefix"));
        $("#store_name").text(btnEl.data("store_name"));
        $("input:checkbox[name=enabled]").prop("checked", btnEl.data("enabled"));

        if (btnEl.data("lsenableautomaticsync") == true) {
            $("#ls_enable_automatic_sync").prop("checked", "checked");
        }
        else {
            $("#ls_enable_automatic_sync").prop("checked");
        }

        $("input:checkbox[name=ls_enable_transfer_slip_commit]").prop("checked", btnEl.data("lsenabletransferslipcommit"));
        $("input:checkbox[name=ls_enable_for_download_all_assets]").prop("checked", btnEl.data("lsenablefordownloadallassets"));
        $("input:checkbox[name=ls_allow_sn_negative_qty]").prop("checked", btnEl.data("lsallowsnnegativeqty"));
        $("input:checkbox[name=gs_one_standard]").prop("checked", btnEl.data("gs_one_standard"));
        $("input:checkbox[name=ls_enable_sync_custom_fields_automatically]").prop("checked", btnEl.data("lsenablesynccustomfieldsautomatically"));
        $("input:checkbox[name=qb_enable_auto_polling_invoices]").prop("checked", btnEl.data("qb_enable_auto_polling_invoices"));


        if (btnEl.data("properties") !== 'null' &&
            btnEl.data("properties") !== null &&
            Object.keys(btnEl.data("properties")).length != 0) {
            const integrationName = btnEl.data("title").toLowerCase();
            const properties = btnEl.data("properties");
            if (properties) {
                switch(integrationName) {
                    case 'twilio':
                        Object.keys(properties).forEach(function (item) {
                            $(`input[id=properties_${integrationName}_${item}]`).val(properties[item]);
                        });
                        break;

                    case 'lightspeed':
                        Object.keys(properties).forEach(function (item) {
                            const checked = (String(properties[item]).toLowerCase() === 'true');
                            $(`input:checkbox[id=properties_${integrationName}_${item}]`).prop("checked", checked);
                        });
                        break;

                    default:
                        break;
                }
            }
        }

        $("#ls_automatic_sync_interval").val(btnEl.data("lsautomaticsyncinterval"));

        $("form").prop("action", btnEl.data("updateurl"));

        $("#editIntegration").modal("show");
    }

    showDownloadCatalog(el: HTMLElement) {
        const btnEl = $(el);
        const downloadCatalogs = ['shopify', 'heartland', 'vend', 'lightspeed', 'odoo', 'quickbook'];
        downloadCatalogs.forEach(i => $(`#${i}_download_catalog`).hide());

        if (downloadCatalogs.includes(btnEl.data("title"))) {
            $(`#${btnEl.data("title")}_download_catalog`).show();
        }
    }

    // Between bad and worst, we don't have more choice for structure, just a few improvements
    showFormOfTreez() {
        $(".api_key_field").show();
        $(".username_field").show();
        $(".password_field").show();
        $(".dispensary_name_field").show();
        $(".ext_client_id_field").show();
        $(".license_field").show();
        $(".url_field").hide();
        $(".token_field").hide();
    }

    showFormOfQuickBook() {
        // $(".url_field").hide();
        // $(".ext_client_id_field").show();
        // $(".api_secret_key_field").show();
        $(".enabled_field").show();
        $(".qb_enable_auto_polling_invoices").show();

    }

    showFormOfOdoo() {
        $(".username_field").show();
        $(".password_field").show();
        $(".url_field").show();
        $(".databse_field").show();
        $(".ls_enable_automatic_sync_field").show();
        $(".ls_enable_transfer_slip_commit_field").show();
        $(".ls_enable_sync_custom_fields_automatically_field").show();
        $(".ls_automatic_sync_interval_field").show();
        $(".ls_enable_not_existed_items_field").show();
        $(".enable_follow_up_email_field").show();
        $(".ls_allow_sn_negative_qty_field").show();
        $(".download-full-catalog-btn").show();
    }

    showFormOfHeartland() {
        $(".domain_prefix_field").show();
        $(".token_field").show();
        $(".url_field").hide();
        $(".ls_enable_automatic_sync_field").show();
        $(".ls_enable_transfer_slip_commit_field").show();
        $(".ls_enable_sync_custom_fields_automatically_field").show();
        $(".ls_automatic_sync_interval_field").show();
        $(".ls_enable_not_existed_items_field").show();
        $(".enable_follow_up_email_field").show();
        $(".ls_allow_sn_negative_qty_field").show();
        $(".download-full-catalog-btn").show();
    }

    showFormOfVend() {
        $(".domain_prefix_field").show();
        $(".token_field").show();
        $(".url_field").hide();
        $(".ls_enable_transfer_slip_commit_field").show();
        $(".ls_enable_sync_custom_fields_automatically_field").show();
        $(".ls_automatic_sync_interval_field").show();
        $(".ls_enable_not_existed_items_field").show();
        $(".enable_follow_up_email_field").show();
        $(".ls_allow_sn_negative_qty_field").show();
        $(".download-full-catalog-btn").show();
    }

    showFormOfPostLog() {
        $(".api_key_field").show();
        $(".error_email_field").show();
    }

    showFormOfLightspeedPos() {
        $(".store_name_field").show();
        $(".url_field").hide();
    }

    showFormOfLightspeed() {
        $(".ls_enable_automatic_sync_field").show();
        $(".ls_enable_transfer_slip_commit_field").show();
        $(".ls_enable_sync_custom_fields_automatically_field").show();
        $(".ls_automatic_sync_interval_field").show();
        $(".ls_allow_sn_negative_qty_field").show();
        $(".download-full-catalog-btn").show();
        $(".url_field").hide();
        $(".properties_fields").show();
        $(".gs_one_standard_field").show();
        $(".gs_one_standard_text_field").show();
        $(".ls_sync_never_existed_items_in_senitron_to_ext").show();
    }

    showFormOfShopify() {
        $(".url_field").hide();
        $(".domain_prefix_field").show();
        $(".api_key_field").show();
        $(".api_secret_key_field").show();
        $(".token_field").show();
        $(".gs_one_standard_field").show();
        $(".shopify_transfer_qty_post_receiving_field").show();
        $(".ls_enable_transfer_slip_commit_field").show();
    }

    showFormOfTwilio() {
        $(".url_field").hide();
        $(".token_field").show();
        $(".twilio_fields").show();
    }

    showGeneralFields() {
        $(".enabled_field").show();
        $(".url_field").show();
    }

    showCredentialFields() {
        $(".username_field").show();
        $(".password_field").show();
    }

    hideAllElements() {
        $(".api_key_field").hide();
        $(".api_secret_key_field").hide();
        $(".enabled_field").hide();
        $(".url_field").hide();
        $(".error_email_field").hide();
        $(".username_field").hide();
        $(".password_field").hide();
        $(".ls_enable_automatic_sync_field").hide();
        $(".ls_enable_transfer_slip_commit_field").hide();
        $(".ls_automatic_sync_interval_field").hide();
        $(".ls_allow_sn_negative_qty_field").hide();
        $(".ls_enable_sync_custom_fields_automatically_field").hide();
        $(".dispensary_name_field").hide();
        $(".ext_client_id_field").hide();
        $(".license_field").hide();
        $(".domain_prefix_field").hide();
        $(".database_field").hide();
        $(".token_field").hide();
        $(".download-full-catalog-btn").hide();
        $(".store_name_field").hide();
        $(".properties_fields").hide();
        $(".twilio_fields").hide();
        $(".gs_one_standard_field").hide();
        $(".qb_enable_auto_polling_invoices").hide();
        $(".ls_sync_never_existed_items_in_senitron_to_ext").hide();
        $(".shopify_transfer_qty_post_receiving_field").hide();
    }
}

export function LoadPage() {
    InitPage("integrations", () => {
        const integrations = new Integrations();
        integrations.init();
    });
}
